import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { SuiContainer, SuiTextInput, SuiLabel } from '@splashthat/sui';
import { getErrorMessage } from 'common/entities/form/selectors';
import { ErrorMessageGreenDot } from './FormErrorMessage.styles';
import { getFormId } from '../../selectors';

const baseClassName = 'FormErrorMessageInput';

const FormErrorMessageInput = (props) => {
    const [internalValue, setInternalValue] = useState(props.value);

    const handleChange = (e) => {
        const value = e.target.value.trim() ? e.target.value : '';

        setInternalValue(value);
        props.setErrorMessage({ [props.errorKey]: value || null });
    };

    return (
        <SuiContainer variation="flex-group">
            <SuiContainer variation="flex-group flex-horizontal-left">
                <SuiLabel text={props.label} />
                {internalValue && internalValue !== props.defaultValue && (
                    <ErrorMessageGreenDot data-qa={`${baseClassName}__ErrorMessageGreenDot`} />
                )}
            </SuiContainer>
            <SuiTextInput
                fullWidth
                value={internalValue}
                placeholder={props.defaultValue}
                autoComplete="off"
                onChange={handleChange}
            />
        </SuiContainer>
    );
};

FormErrorMessageInput.propTypes = {
    errorKey: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    defaultValue: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    setErrorMessage: PropTypes.func.isRequired,
};

const mapStateToProps = (state, props) => ({
    value: getErrorMessage(state, getFormId(state), props.errorKey),
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(FormErrorMessageInput);
